(function ($, njm) {
    'use strict';

    njm.views.getQuoteDynamicProductDefined = Backbone.View.extend({

        events: {
            'click .selected': 'openSelect',
            'click #selectState a': 'selectState',
            'click #gotoQuote': 'navigate'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$state = $('#selectState .selected');
            this.$button = $('#gotoQuote');
            this.$geoState = this.$('input[name=geostate]');
            this.$telephone = this.$('#quoteTelephone');

            this.data = window.quoteApps;
            this.selected = {
                stateIndex: 0,
                products: [],
                productIndex: 0,
                device: 'desktop'
            };

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.selected.device = 'mobile';
            }

            this.$button.addClass('disabled');

            if ($('#selectState a.active').length) {
                this.setState($('#selectState a.active').text());
                this.loadUrl();
            }

            if (this.$geoState.val() !== '') {
                this.setState(this.$geoState.val());
                this.loadUrl();
            }
        },

        /**
         * Open custom selects
         */
        openSelect: function (e) {
            var $select = $(e.currentTarget).parent();

            if (!$select.hasClass('disabled')) {
                if ($select[0].id === "selectState") {
                    $('#selectProduct ul').hide();
                }

                $(e.currentTarget)
                    .parent().toggleClass('open')
                    .find('ul').slideToggle(200);
            }
        },

        /**
         * Select  State
         */
        selectState: function (e) {
            e.preventDefault();
            var $selected = $(e.currentTarget);

            this.setState($selected.text());

            this.$button.addClass('disabled');

            $selected
                .addClass('active')
                .parent().siblings().children('a').removeClass('active')
                .parents('ul').slideToggle(200)
                .parent().toggleClass('open');
            
            this.loadUrl();
        },

        /**
         * Set State
         * @param {string} state
         */
        setState: function (state) {
            this.$state.text(state);
            this.selected.stateIndex = this.findStateIndex(state);
            this.$button.data('layerState', state);
        },
       
        findStateIndex: function (stateName) {
            var toReturn;
            $.each($('#selectState a'), function (key, value) {
                if (value.text === stateName) {
                    toReturn = key;
                    return false;
                }
            });

            return toReturn;
        },

        /**
        * Load URL for button
        */
        loadUrl: function () {
            var queryString = window.location.search;
            var url = '';
            var target = '';
            var phoneLink = '';
            var phoneText = '';

            if(this.data[this.selected.stateIndex] !== undefined && this.data[this.selected.stateIndex].products.length){
                this.$product = this.data[this.selected.stateIndex].products[0];
                this.$button.data('layerProduct', this.$product.name);

                url = this.$product.desktop;
                target = this.$product.desktopTarget;
                phoneLink = this.$product.phoneLink;
                phoneText = this.$product.phoneText;

                if (this.selected.device === 'mobile') {
                    url = this.$product.mobile;
                    target = this.$product.mobileTarget;
                }

                this.$button
                    .attr({ 'href': url + queryString, 'target': target })
                    .removeClass('disabled');
                
                    if (phoneText !== '' && phoneLink !== ''){
                        this.$telephone.attr({'href': phoneLink});
                        this.$telephone.text(phoneText);
                    }
                    else{
                        this.$telephone.removeAttr('href');
                        this.$telephone.text('');
                    }
            }
        },

        /**
        * Button click
        */
        navigate: function (e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                e.preventDefault();
            }
        }
    });
})(jQuery, njm);
